/**
 * 文档服务
 * 从 AZ_AI_MVR_H5/src/services/documents.ts 迁移
 */
import request from "../../utils/request";

/** 根据文档 ID 批量获取文档详情 */
export function getDocumentsByIds(ids: string[]) {
  return request.post("/document/documentlist/getdocumentid", ids).then((r) => r.data);
}

/** 搜索文档列表（Add sources 弹窗） */
export function searchDocumentList(params: Record<string, any>) {
  return request.post("/project/documentlist/searchdocumentlist", params).then((r) => r.data);
}
